import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Dashboard/produccion`, method: 'GET', body: null, token: token})
}